const baseURL = `${process.env.PUBLIC_URL || ""}/assets`;

const toLowerSlug = (str: string) => str.replace(/\s+/g, "").toLowerCase();

export const galleryDataURL = `${baseURL}/data/gallery.data.json`;

export const skillsDataURL = `${baseURL}/data/skills.data.json`;

export const enImageURL = `${baseURL}/main/en.png`;

export const esImageURL = `${baseURL}/main/es.png`;

export const mainBgURL = `${baseURL}/main/bg.jpg`;

export const getGalleryImageURL = (slug: string): string =>
  `${baseURL}/images/gallery/${slug}.png`;

export const getGalleryTNImageURL = (slug: string): string =>
  `${baseURL}/images/gallery/${slug}-tn.png`;

export const getSkillLogoURL = (slug: string): string =>
  `${baseURL}/images/skillLogos/${toLowerSlug(slug)}.png`;

type DocsURLObjType = {
  resume: string;
  cover: string;
};

export const docsURLObj: DocsURLObjType = {
  resume: `${baseURL}/resume/Kevin Smith - CV.pdf`,
  cover: `${baseURL}/resume/Kevin Smith - Cover Letter.pdf`,
};
